module.exports = __webpack_public_path__ + "img/8mmzuantoujia.prt.fdd476ea.jpg";